import { API_VEHICLE_UPLOAD_PHOTO } from 'hooks/carRental/_';
export default {
  searchFormView: [
    { xtype: 'grid', xprops: { colums: '3' }, children:
      [
        {
          name: 'action_tag', xtype: 'input', xprops: {
            allowClear: true, placeholder: '请输入', label: '活动标签'
          }
        },
        {
          name: 'action_code', xtype: 'input', xprops: {
            allowClear: true, placeholder: '请输入', label: '活动ID'
          }
        },
        { name: 'action_name', xtype: 'input', xprops: {
          placeholder: '请输入', allowClear: true, label: '活动名称' }
        },
        { name: 'action_status', xtype: 'enumSelect', xprops: {
          placeholder: '请选择', allowClear: true, label: '活动状态', clearReturnUndefined: true, enumKey: 'f_activity_status_list_saas', mode: 'multiple', filterOption: false }
        },
        { name: 'enroll_status', xtype: 'enumSelect', xprops: {
          placeholder: '请选择', allowClear: true, label: '报名状态', clearReturnUndefined: true, enumKey: 'f_activity_apply_status_list', mode: 'multiple', filterOption: false}
        },
      ]
    },
  ],
  drawerView: [
    { xtype: 'typography', xprops: {}, children:
      [
        { xtype: 'title', title: '活动说明' },
        { name: 'action_name', xtype: 'SPText', xprops: { label: '活动名称' } },
        { name: 'reg_time', xtype: 'SPText', xprops: { label: '报名时间' } },
        { name: 'action_tag', xtype: 'SPText', xprops: { label: '活动标签'} },
        { name: 'action_time', xtype: 'SPText', xprops: { label: '活动时间' } },
        { name: 'action_desc', xtype: 'SPText', xprops: { label: '活动简介', } },
        { name: 'action_images', xtype: 'SPImagesPreview', xprops: { label: '介绍图片' } },
        { name: 'attention', xtype: 'SPText', xprops: { label: '注意事项', style: { whiteSpace: 'pre-wrap', display: 'inline-block', marginTop: '5px' } } },
        { xtype: 'title', title: '活动规则' },
        { name: 'cost_bear_metd', xtype: 'EnumValueToText', xprops: { nameSpace: 'f_cost_bear_metd', label: '成本承担方式' } },
        { name: 'overlay_discounts', xtype: 'EnumValueToText', xprops: { nameSpace: 'f_overlay_discounts', label: '优惠同享' } },
        { name: 'activity_veh_group', xtype: 'SPText', xprops: { label: '活动车型' } },
        { name: 'activity_cities', xtype: 'SPText', xprops: { label: '活动城市' } },
        { name: 'pick_up_and_return_veh_time', xtype: 'PRTimeLimit', xprops: { label: '取还车时间限制', initialValue: '不限制' } },
        { name: 'holiday', xtype: 'HolidayTips', xprops: { nameSpace: 'f_activity_holiday_limit_list', label: '节假日规则'} },
        { name: 'reserve_time', xtype: 'SPText', xprops: { label: '提前预订时间范围', initialValue: '不限制' } },
        { name: 'amount_limit', xtype: 'SPText', xprops: { label: '每单优惠金额上限' } },
        { name: 'discount_plan', xtype: 'DiscountPlan', xprops: { label: '优惠方式' } },
        { xtype: 'title', title: '报名填写' },
      ]
    },
  ],
}